import EditEventFormSingleType from './EditEventFormSingleType.jsx';
import EditEventFormPriceType from './EditEventFormPriceType.jsx';
import EditEventFormInputType from './EditEventFormInputType.jsx';
import EditEventFormDateTime from './EditEventFormDateTime.jsx';

const generateTotalVisitorsString = (visitorsValues) => {
    const totalNumber = Object.values(visitorsValues).reduce((sum, value) => sum + value);
    return 'insgesamt ' + totalNumber.toString() + ' Personen';
}

const EditEventFormElement = ({ id, element, values, form_data, form_settings, visitorsTotalNumber, theatresTotalNumber, activeField, setActiveField, setFieldValue })  => {
    const type = element.type;
    let typeValues, formData, settings;
    if (type === 'visitors' || type === 'theatres') {
        typeValues = { ...values[type], ...values[type+'_other_fees'] }
        formData = { ...form_data[type], ...form_data[type+'_other_fees'] }
        settings = {
            items: { ...form_settings[type].items, ...form_settings[type+'_other_fees'].items },
            order: [ ...form_settings[type].order, ...form_settings[type+'_other_fees'].order ]
        }
    } else if(type==='input'){
        typeValues = values['input_types'];
        formData = form_data['input_types'];
        settings = form_settings['input_types'];
    }
    else {
        typeValues = values[type];
        formData = form_data[type];
        settings = form_settings[type];
    }

    switch(type) {
        case 'event_types':
            return <EditEventFormSingleType
                headline="Veranstaltungs-Art"
                fieldName={type}
                keyName="event_type_name"
                keyId="event_type_id"
                currValue={typeValues}
                formValue={formData}
                settings={settings}
                activeField={activeField}
                setActiveField={setActiveField}
            />
        case 'program_types':
            return <EditEventFormSingleType
                headline="Programm-Art"
                fieldName={type}
                keyName="program_type_name"
                keyId="program_type_id"
                currValue={typeValues}
                formValue={formData}
                settings={settings}
                activeField={activeField}
                setActiveField={setActiveField}
            />
        case 'date_types':
            return <EditEventFormDateTime
                headline='Datum und Uhrzeit'
                formSettings={form_settings}
                values={values}
                formData={form_data}

                activeField={activeField}
                setActiveField={setActiveField}
                setFieldValue={setFieldValue}
            />
        case 'visitors':
            return <EditEventFormPriceType
                headline={"Besucher:innen"}
                headlineAddition={" (" + generateTotalVisitorsString(values.visitors) + ")"}
                fieldName={type}
                currValues={typeValues}
                currPriceValues={{ ...values.prices[type], ...values.prices[type+'_other_fees'] }}
                formValues={formData}
                formPriceValues={{ ...form_data.prices[type], ...form_data.prices[type+'_other_fees'] }}
                settings={settings}
                totalNumber={visitorsTotalNumber}
                activeField={activeField}
                setActiveField={setActiveField}
            />
        case 'theatres':
            return <EditEventFormPriceType
                headline="Säle"
                fieldName={type}
                currValues={typeValues}
                currPriceValues={{ ...values.prices[type], ...values.prices[type+'_other_fees'] }}
                formValues={formData}
                formPriceValues={{ ...form_data.prices[type], ...form_data.prices[type+'_other_fees'] }}
                settings={settings}
                totalNumber={theatresTotalNumber}
                activeField={activeField}
                setActiveField={setActiveField}
            />
        case 'input':
            return <EditEventFormInputType
                headline={form_settings.element_types.items[id].label}
                fieldName={type}
                formValues={formData}
                currValues={typeValues}
                arrayOfIds={form_settings.element_types.items[id].input_types}
                settings={settings.items}
                activeField={activeField}
                setActiveField={setActiveField}
            />
        default:
            return ''
    }
}

export default EditEventFormElement